export enum Metrics {
  APPLICATION_RATE = 'APPLICATION_RATE',
  COUNT_USERS = 'COUNT_USERS',
  COUNT_USERS_ACTIVATED = 'COUNT_USERS_ACTIVATED',
  COUNT_USERS_RETAINED = 'COUNT_USERS_RETAINED',
  COUNT_USERS_REACTIVATED = 'COUNT_USERS_REACTIVATED',
  AVG_BASKET_SPEND_WITH_PROMO = 'AVG_BASKET_SPEND_WITH_PROMO',
  AVG_COST_PER_ACTIVATION = 'AVG_COST_PER_ACTIVATION',
  AVG_COST_PER_ORDER = 'AVG_COST_PER_ORDER',
  AVG_COST_PER_RESURRECTION = 'AVG_COST_PER_RESURRECTION',
  AVG_COST_PER_USER = 'AVG_COST_PER_USER',
  AVG_COST_PER_USER_ACTIVATED = 'AVG_COST_PER_USER_ACTIVATED',
  AVG_COST_PER_USER_RETAINED = 'AVG_COST_PER_USER_RETAINED',
  AVG_COST_PER_USER_REACTIVATED = 'AVG_COST_PER_USER_REACTIVATED',
  AVG_DAILY_CAMPAIGN_SPEND = 'AVG_DAILY_CAMPAIGN_SPEND',
  AVG_UNIT_SPEND_WITH_PROMO = 'AVG_UNIT_SPEND_WITH_PROMO',
  LAST_ETL_UPDATE = 'MAX_UPDATED_AT_DATE_TIME_UTC',
  NUM_ACTIVE_CAMPAIGNS = 'NUM_ACTIVE_CAMPAIGNS',
  NUM_DISTINCT_CAMPAIGNS = 'NUM_DISTINCT_CAMPAIGNS',
  NUM_ENDING_SOON_CAMPAIGNS = 'NUM_ENDING_SOON_CAMPAIGNS',
  NUM_ORDERS_OFFERS = 'NUM_ORDERS_OFFERS',
  OFFER_CONVERSION_RATE = 'OFFER_CONVERSION_RATE',
  REDEMPTION_RATE = 'REDEMPTION_RATE',
  REORDER_RATE_28_DAY = 'REORDER_RATE_28_DAY',
  RETURN_ON_AD_SPEND = 'RETURN_ON_AD_SPEND',
  SUM_ACTIVATIONS = 'SUM_ACTIVATIONS',
  SUM_APPLICATIONS = 'SUM_APPLICATIONS',
  SUM_ATTRIBUTED_SALES = 'SUM_ATTRIBUTED_SALES',
  SUM_CAMPAIGN_SPEND = 'SUM_CAMPAIGN_SPEND',
  SUM_CAMPAIGN_SPEND_OUTSTANDING = 'SUM_CAMPAIGN_SPEND_OUTSTANDING',
  SUM_CLICKS = 'FACT_CI_SUM_CLICKS',
  SUM_IMPRESSIONS = 'FACT_CI_SUM_IMPRESSIONS',
  SUM_ORDERS_OUTSTANDING = 'SUM_ORDERS_OUTSTANDING',
  SUM_REDEMPTIONS = 'SUM_REDEMPTIONS',
  SUM_RESURRECTIONS = 'SUM_RESURRECTIONS',
  SUM_USERS = 'SUM_USERS',
  SUM_USERS_OFFERS = 'SUM_USERS_OFFERS',
  SUM_ATTRIBUTED_ERV = 'SUM_ATTRIBUTED_ERV',
}

export enum Dimensions {
  DATE_PT = 'DATE_PT',
  WEEK_SAT_PT = 'WEEK_SAT_PT',
  WEEK_SUN_PT = 'WEEK_SUN_PT',
  WEEK_MON_PT = 'WEEK_MON_PT',
  WEEK_TUE_PT = 'WEEK_TUE_PT',
  WEEK_WED_PT = 'WEEK_WED_PT',
  WEEK_THU_PT = 'WEEK_THU_PT',
  WEEK_FRI_PT = 'WEEK_FRI_PT',
  MONTH_PT = 'MONTH_PT',
  CAMPAIGN = 'CAMPAIGN',
  CAMPAIGN_ENDING_SOON = 'CAMPAIGN_ENDING_SOON',
  CAMPAIGN_ID = 'CAMPAIGN_ID',
  CAMPAIGN_TYPE = 'CAMPAIGN_TYPE',
  COUNTRY_NAME = 'COUNTRY_NAME',
  DIM_CAMPAIGN_END_DATE = 'DIM_CAMPAIGN_END_DATE',
  DIM_CAMPAIGN_NAME = 'DIM_CAMPAIGN_NAME',
  DIM_CAMPAIGN_OBJECTIVE = 'DIM_CAMPAIGN_OBJECTIVE',
  DIM_CAMPAIGN_START_DATE = 'DIM_CAMPAIGN_START_DATE',
  DIM_CAMPAIGN_STATUS = 'DIM_CAMPAIGN_STATUS',
  DIM_DISCOVERABILITY = 'DIM_DISCOVERABILITY',
  DIM_STORE_CONFIGURATION = 'DIM_STORE_CONFIGURATION',
  IS_INSTACART_STORE_CONFIGURATION = 'IS_INSTACART_STORE_CONFIGURATION',
  DIM_USER_SEGMENT = 'DIM_USER_SEGMENT',
  DIM_USER_SEGMENT_CAMPAIGN_TYPE = 'DIM_USER_SEGMENT_CAMPAIGN_TYPE',
  IMPRESSION_SOURCE = 'IMPRESSION_SOURCE',
  INSIGHTS_PORTAL_ORDER_SOURCE = 'INSIGHTS_PORTAL_ORDER_SOURCE',
  TAAS_USER_SEGMENT = 'TAAS_USER_SEGMENT',
  TAAS_USER_SEGMENT_CAMPAIGN_TYPE = 'TAAS_USER_SEGMENT_CAMPAIGN_TYPE',
  WAREHOUSE = 'WAREHOUSE',
  WAREHOUSE_LOCATION = 'WAREHOUSE_LOCATION',
  WAREHOUSE_LOCATION_CODE = 'WAREHOUSE_LOCATION_CODE',
  WAREHOUSE_LOCATION_REGION = 'WAREHOUSE_LOCATION_REGION',
  WAREHOUSE_LOCATION_STATE = 'WAREHOUSE_LOCATION_STATE',
  ZONE_STATE = 'ZONE_STATE',
  WAREHOUSE_LOCATION_GROUP = 'WAREHOUSE_LOCATION_GROUP',
}
